import {
  BaseCommentInfoFragment,
  BaseCommentInfoFragmentDoc,
  CommentInfoFragment,
  CommentInfoFragmentDoc,
} from 'gqlTypes'
import { dataIdFromObject } from 'graphql/apolloClient'
import { DataProxy } from 'apollo-cache'

interface ReadFromCache {
  cache: DataProxy
  id: string
}

interface WriteCommentToCache {
  cache: DataProxy
  comment: CommentInfoFragment
}

interface WriteReplyToCache {
  cache: DataProxy
  comment: BaseCommentInfoFragment
}

export const readCommentFromCache = ({ cache, id }: ReadFromCache) =>
  cache.readFragment({
    fragment: CommentInfoFragmentDoc,
    fragmentName: 'CommentInfo',
    id: dataIdFromObject({
      __typename: 'Comment',
      identifier: id,
    }) as string,
  }) as CommentInfoFragment

export const writeCommentToCache = ({ cache, comment }: WriteCommentToCache) =>
  cache.writeFragment<CommentInfoFragment>({
    fragment: CommentInfoFragmentDoc,
    fragmentName: 'CommentInfo',
    id: dataIdFromObject(comment) as string,
    data: comment,
  })

export const updateCommentFromCache = ({
  cache,
  comment,
}: WriteCommentToCache) => {
  const commentFromCache = readCommentFromCache({
    cache,
    id: comment.identifier,
  })

  if (commentFromCache) {
    writeCommentToCache({ cache, comment })
  }

  return null
}

export const readReplyFromCache = ({ cache, id }: ReadFromCache) =>
  cache.readFragment({
    fragment: BaseCommentInfoFragmentDoc,
    fragmentName: 'BaseCommentInfo',
    id: dataIdFromObject({
      __typename: 'Comment',
      identifier: id,
    }) as string,
  }) as BaseCommentInfoFragment

export const writeReplyToCache = ({ cache, comment }: WriteReplyToCache) =>
  cache.writeFragment<BaseCommentInfoFragment>({
    fragment: BaseCommentInfoFragmentDoc,
    fragmentName: 'BaseCommentInfo',
    id: dataIdFromObject(comment) as string,
    data: comment,
  })

export const updateReplyFromCache = ({ cache, comment }: WriteReplyToCache) => {
  const commentFromCache = readReplyFromCache({
    cache,
    id: comment.identifier,
  })

  if (commentFromCache) {
    writeReplyToCache({ cache, comment })
  }

  return null
}
